module.exports = __webpack_public_path__ + "static/media/3.c4ca1505.jpg";